import { Close } from "@mui/icons-material";
import AlertListener from "components/AlertListener";
import lynxColors from "modules/lynxColors";
import { SnackbarProvider, useSnackbar } from "notistack";
import React, { FC } from "react";

type Props = {
  children: React.ReactNode | React.ReactNode[];
};

// Custom snackbar components for notistack v3
const CustomSnackbar = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  const { variant, message, id, ...rest } = props;
  const { closeSnackbar } = useSnackbar();

  const getBackgroundColor = () => {
    switch (variant) {
      case "success":
        return lynxColors.success;
      case "error":
        return lynxColors.error;
      case "warning":
        return lynxColors.warning;
      case "info":
        return lynxColors.primary;
      default:
        return "#323232";
    }
  };

  return (
    <div
      ref={ref}
      {...rest}
      style={{
        background: getBackgroundColor(),
        color: "white",
        padding: "16px",
        borderRadius: "4px",
        boxShadow:
          "0 3px 5px -1px rgba(0,0,0,0.2), 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minWidth: "300px",
        maxWidth: "500px",
        margin: "8px",
        ...rest.style,
      }}
    >
      <div style={{ flex: 1, marginRight: "8px", paddingRight: "4px" }}>
        {message}
      </div>
      <div
        style={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Close
          sx={{
            cursor: "pointer",
            color: "white",
            fontSize: "24px",
            padding: "6px",
            borderRadius: "50%",
            transition: "background-color 0.2s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            },
          }}
          onClick={() => closeSnackbar(id)}
        />
      </div>
    </div>
  );
});

const AlertProvider: FC<Props> = ({ children }) => {
  return (
    <SnackbarProvider
      Components={{
        success: CustomSnackbar,
        error: CustomSnackbar,
        warning: CustomSnackbar,
        info: CustomSnackbar,
        default: CustomSnackbar,
      }}
      anchorOrigin={{ horizontal: "center", vertical: "top" }}
      autoHideDuration={5000}
    >
      {children}
      <AlertListener />
    </SnackbarProvider>
  );
};

export default AlertProvider;
